import React from 'react';

interface PageSizeSelectorProps {
  pageSize: number;
  pageSizeOptions?: number[];
  onPageSizeChange: (size: number) => void;
}

const PageSizeSelector: React.FC<PageSizeSelectorProps> = ({
  pageSize,
  pageSizeOptions = [5, 10, 20, 50],
  onPageSizeChange,
}) => (
  <div className="flex items-center gap-2">
    <span className="text-[12px] md:text-sm text-black dark:text-white">Entries</span>
    <select
      value={pageSize}
      onChange={(e) => onPageSizeChange(Number(e.target.value))}
      className="border border-gray-300 rounded px-1 md:px-2 py- md:py-1 text-[12px] md:text-sm focus:outline-none focus:ring-2 focus:ring-primary dark:bg-transparent dark:text-white"
    >
      {pageSizeOptions.map((size) => (
        <option className="dark:text-black" key={size} value={size}>
          {size}
        </option>
      ))}
    </select>
    <span className="text-[12px] md:text-sm text-black dark:text-white">Show</span>
  </div>
);

export default PageSizeSelector;
